import { create } from 'zustand';
import { ProfileModalType } from '@habity/types';

interface ModalState {
  galleryOpen: boolean;
  galleryImageId?: string;
  floorPlanOpen: boolean;
  virtualTourOpen: boolean;
  viewingsOpen: boolean;
  handleOpen: (params: ProfileModalType) => void;
}

export const useModalStore = create<ModalState>((set) => ({
  galleryOpen: false,
  galleryImageId: undefined,
  floorPlanOpen: false,
  virtualTourOpen: false,
  viewingsOpen: false,
  handleOpen: ({ modalType, open, imageId }: ProfileModalType) => {
    if (modalType === 'gallery') {
      set({ galleryOpen: open, galleryImageId: imageId });
    } else if (modalType === 'floorPlan') {
      set({ floorPlanOpen: open });
    } else if (modalType === 'virtualTour') {
      set({ virtualTourOpen: open });
    } else if (modalType === 'viewings') {
      set({ viewingsOpen: open });
    } else if (modalType === 'project') {
      set({ galleryOpen: open });
    }
  },
}));
